import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function CartInner() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);

  // Load cart from sessionStorage on mount
  useEffect(() => {
    const savedCart = JSON.parse(sessionStorage.getItem("cart")) || [];
    setCartItems(savedCart);
  }, []);

  // Save cart to sessionStorage when updated
  const updateSession = (updated) => {
    setCartItems(updated);
    sessionStorage.setItem("cart", JSON.stringify(updated));
  };

  const updateQuantity = (id, amount) => {
    const updated = cartItems.map((item) =>
      item.id === id
        ? { ...item, quantity: Math.max(1, item.quantity + amount) }
        : item
    );
    updateSession(updated);
  };

  const removeItem = (id) => {
    const updated = cartItems.filter((item) => item.id !== id);
    updateSession(updated);
  };

  const cartTotal = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  // Redirect if cart empty
  if (cartItems.length === 0) {
    return (
      <div className="text-center py-5">
        <h3>Your cart is empty.</h3>
        <Link to="/shop" className="th-btn mt-3">
          Go Shopping
        </Link>
      </div>
    );
  }

  // Image helper (base64 & string)
  const getImage = (item) => {
    if (!item || !item.imageUrl) return "/assets/img/placeholder.png";

    if (Array.isArray(item.imageUrl)) return item.imageUrl[0];

    return item.imageUrl;
  };

  return (
    <div className="th-cart-wrapper space-top space-extra-bottom">
      <div className="container">
        <form className="woocommerce-cart-form">
          <table className="cart_table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Product Name</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Total</th>
                <th>Remove</th>
              </tr>
            </thead>

            <tbody>
              {cartItems.map((item) => (
                <tr className="cart_item" key={item.id}>
                  <td>
                    <Link
                      className="cart-productimage"
                      to={`/product-details/${item.id}`}
                    >
                      <img
                        width={91}
                        height={91}
                        src={getImage(item)}
                        alt={item.name}
                      />
                    </Link>
                  </td>

                  <td>
                    <Link
                      className="cart-productname"
                      to={`/product-details/${item.id}`}
                    >
                      {item.name}
                    </Link>
                  </td>

                  <td>
                    <span className="amount">
                      <bdi>
                        <span>$</span>
                        {item.price}
                      </bdi>
                    </span>
                  </td>

                  <td>
                    <div className="quantity">
                      <button
                        className="quantity-minus qty-btn"
                        type="button"
                        onClick={() => updateQuantity(item.id, -1)}
                      >
                        <i className="far fa-minus" />
                      </button>

                      <input
                        type="number"
                        className="qty-input"
                        value={item.quantity}
                        readOnly
                      />

                      <button
                        className="quantity-plus qty-btn"
                        type="button"
                        onClick={() => updateQuantity(item.id, 1)}
                      >
                        <i className="far fa-plus" />
                      </button>
                    </div>
                  </td>

                  <td>
                    <span className="amount">
                      <bdi>
                        <span>$</span>
                        {item.price * item.quantity}
                      </bdi>
                    </span>
                  </td>

                  <td>
                    <button
                      onClick={() => removeItem(item.id)}
                      className="remove"
                    >
                      <i className="fal fa-trash-alt" />
                    </button>
                  </td>
                </tr>
              ))}

              {/* NO Coupon / No Update Cart */}
              <tr>
                <td colSpan={6} className="actions text-end">
                  <Link to="/shop" className="th-btn">
                    Continue Shopping
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </form>

        {/* Cart Total Box */}
        <div className="row justify-content-end">
          <div className="col-md-8 col-lg-7 col-xl-6">
            <h2 className="h4 summary-title">Cart Summary</h2>
            <table className="cart_totals">
              <tbody>
                <tr>
                  <td>Subtotal</td>
                  <td>
                    <span className="amount">
                      <bdi>
                        <span>$</span>
                        {cartTotal}
                      </bdi>
                    </span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr className="order-total">
                  <td>Total</td>
                  <td>
                    <strong>
                      <span className="amount">
                        <bdi>
                          <span>$</span>
                          {cartTotal}
                        </bdi>
                      </span>
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </table>

            <div className="wc-proceed-to-checkout mb-30">
              <Link to="/checkout" className="th-btn">
                Proceed to Checkout
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartInner;
